module.exports = __webpack_public_path__ + "img/photo_2024-04-02_15-32-30.6424dbb3.jpg";